/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

function useElementHeights (p) {
    const {
        selectors = [],
    } = p;

    const [elementsHeight, setElementsHeight] = useState(0);

    useEffect(() => {
        detecHeight();
    }, []);

    function detecHeight () {
        if (selectors.length >= 0) {
            const selector = selectors[0];
            const el = document.querySelector(selector);
            if (el) {
                let totalHeight = 0;
                for (let i = 0; i < selectors.length; i++) {
                    const item = document.querySelector([selectors[i]]);
                    if (item) {
                        totalHeight = totalHeight + item.offsetHeight;
                    }
                }
                setElementsHeight(totalHeight);
            } else {
                setTimeout(detecHeight, 100);
            }
        }
    }

   
    return {
        elementsHeight,
    };
}

export default useElementHeights;
